import { LAYOUT } from '@admin/router/constant'

// 调拨v2
const transferRouter = {
  path: '/box-list-manage',
  name: '',
  component: LAYOUT,
  children: [
    {
      path: '/wms/box-list-manage/box-list',
      name: 'wmsBoxListManageBoxList',
      component: () => import('@admin/views/wms/boxListManagement/boxList/index.vue'),
      meta: { title: '集箱单管理' },
    },
    {
      path: '/wms/box-list-manage/work',
      name: 'wmsBoxListManageWork',
      component: () => import('@admin/views/wms/boxListManagement/work/index.vue'),
      meta: { title: '集箱作业' },
    },
  ],
}

export default [transferRouter]
